import { ModalWrapper } from 'src/components'
import { Formik } from 'formik'

import { ESettingsModelOrToolFields, IHashTagsSettingsForm } from 'src/types'

import { useStyles } from '../form/styles'
import { SettingListItemsForm } from '../form/array-list-item-form'

interface IProps {
  handleUpdate: (list: string[]) => void
  open: boolean
  handleClose: () => void
  initialTags: string[]
}

export const StoreIdsModal = ({ handleUpdate, initialTags = [], open, handleClose }: IProps) => {
  const classes = useStyles()

  const handleSubmit = async (values: IHashTagsSettingsForm) => {
    handleUpdate(values.hashTags)
    handleClose()
  }

  const chatHelper = 'Enter vector store ID and use "::" to add a Name.'
  return (
    <ModalWrapper open={open} onClose={handleClose} className={classes.modalWrapper}>
      <Formik initialValues={{ hashTags: initialTags, newTag: '' }} onSubmit={handleSubmit}>
        <SettingListItemsForm
          handleClose={handleClose}
          helperText={chatHelper}
          placeholder={'e.g. 123456::Name'}
        />
      </Formik>
    </ModalWrapper>
  )
}
